import { render } from "./dconfig.vue?vue&type=template&id=e2f0b2e8&scoped=true"
const script = {}

import "./dconfig.vue?vue&type=style&index=0&id=e2f0b2e8&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f0b2e8"]])

export default __exports__